// ABOUTME: OneOnOneTime button component for parent-child quality time tracking (Issue #1064)
// ABOUTME: Displays illustrated Kala icon and records BehaviorType.OneOnOneTime with no ladder movement

import React from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import { KalaIcon } from '../utils/behaviorUtils';
import { BehaviorType } from '../types/api';
import { StyledActionButton, mobileIconOnlySx } from './shared/StyledActionButton';
import { BilingualLabel } from './BilingualLabel';
import { useEffectiveLabelLanguageMode } from '../hooks/useEffectiveLabelLanguageMode';
import naluV1Theme from '../theme/theme.nalu-v1';

interface OneOnOneTimeButtonProps {
  child: { childId: number | string; name?: string };
  onBehaviorRecorded?: (behaviorType: BehaviorType) => void;
}

const OneOnOneTimeButton: React.FC<OneOnOneTimeButtonProps> = ({
  onBehaviorRecorded
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const labelMode = useEffectiveLabelLanguageMode();

  const handleOneOnOneTime = () => {
    // Trigger the callback - let the parent handle the API call
    if (onBehaviorRecorded) {
      onBehaviorRecorded(BehaviorType.OneOnOneTime);
    }
  };

  return (
    <StyledActionButton
      data-testid="one-on-one-time-button"
      variant="outlined"
      onClick={handleOneOnOneTime}
      startIcon={<KalaIcon data-testid="AccessTimeIcon" />}
      aria-label="Record Let Go time with child"
      tabIndex={0}
      sx={isMobile ? mobileIconOnlySx(theme.logoSrc === naluV1Theme.logoSrc) : undefined}
    >
      {isMobile ? null : <BilingualLabel term="kala" english="Let Go" mode={labelMode ?? 'english-lead'} />}
    </StyledActionButton>
  );
};

export default OneOnOneTimeButton;
